export default __webpack_public_path__ + "media/titles/title_4_locale_nb-3b4ac9fd.png";